import { memo } from 'react';
import Icon from '@ant-design/icons';
import { IconBaseProps } from '@ant-design/icons/lib/components/Icon';
import { ReactComponent as PdfIcon } from './assets/pdf.svg';
import { ReactComponent as WordIcon } from './assets/word.svg';
import { ReactComponent as ExcelIcon } from './assets/excel.svg';
import { ReactComponent as TxtIcon } from './assets/txt.svg';
import { ReactComponent as FileIcon } from './assets/file.svg';

interface JolectFileIconProps {
  ext: string;
  className?: IconBaseProps['className'];
}

const ICON_MAP: Record<string, typeof FileIcon> = {
  pdf: PdfIcon,
  doc: WordIcon,
  docx: WordIcon,
  xls: ExcelIcon,
  xlsx: ExcelIcon,
  txt: TxtIcon,
};

/**
 * Jolect 文件附件专用文件类型图标（设计稿图标）。
 * 未命中的类型（图片、ppt、zip 等）统一使用通用文件图标兜底。
 */
export const JolectFileIcon = memo((props: JolectFileIconProps) => {
  const { ext, ...iconProps } = props;

  let type = ext;
  if (type.startsWith('.')) {
    type = type.substring(1);
  }

  const component = ICON_MAP[type.toLowerCase()] || FileIcon;

  return <Icon {...iconProps} component={component} />;
});
